import { useEffect, useState } from "react";
import WordCloudChart from "./Charts/WordCloudChart";

const DiseaseWorldCloud = (props) => {
  const [plotData, setPlotData] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch('data/diseases/diseases_wordcloud.json')
      .then((response) => response.json())
      .then((json) => {
        setPlotData(json[props.label.toLowerCase()]);
      })
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  return <WordCloudChart data={plotData}></WordCloudChart>;
};

export default DiseaseWorldCloud;
